
import React from 'react';
import ModalFrame from '../../../ModalFrame';
import CloneSurvey from './CloneSurvey';

class CloneSurveyModalController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);

  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'cloneSurvey' ?
          <ModalFrame
            title="CLONE A SURVEY"
            desktopWidth="60%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <CloneSurvey
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default CloneSurveyModalController;
